<template>
  <zm-drawer
    :visible="visible"
    :title="title"
    :footer="footer"
    :width="'75%'"
    :placement="placement"
    @cancel="cancel"
    class="modal"
  >
    <div slot="drawerBody">
      <a-form :form="form" @submit="handleSubmit" labelAlign="right">
        <div class="basicParameters">
          <div class="titleDiv">
            <div class="title">基本信息</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="设备名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入设备名称"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['name',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入设备名称!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="是否虚拟设备" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-decorator="['sign',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择是否虚拟设备!' }]}]" :allowClear="true" placeholder="请选择是否虚拟设备">
                  <a-select-option v-for="(item, index) in yesOrNoSignList" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="规格型号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入规格型号"
                  autocomplete="off"
                  v-decorator="['specification',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入规格型号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="公司名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-tree-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-decorator="['subcompanyid',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择公司名称!' }]}]"
                  placeholder="请选择公司名称"
                  style="width: 100%"
                  allow-clear
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :treeData="companyNameList"
                  :replaceFields="{
                    title: 'url',
                    key: 'id',
                    value: 'id'
                  }"
                  @change="changeCompany"
                ></a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="设备状态" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" @change="changeEquipmentStatus" v-decorator="['equipmentStatus',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择设备状态!' }]}]" :allowClear="true" placeholder="请选择设备状态">
                  <a-select-option v-for="(item, index) in equipmentStatusList" :key="index" :value="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="归口部门" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @change="changeRelevantDept"
                  v-decorator="['relevantdeptid',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择归口部门!' }]}]"
                  :allowClear="true"
                  placeholder="请选择归口部门">
                  <a-select-option v-for="(item, index) in relevantDepartmentList" :key="index" :value="item.deptId">
                    {{ item.departmentname }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="使用部门" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-tree-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-decorator="['usedeptid',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择使用部门!' }]}]"
                  style="width: 100%"
                  placeholder="请选择使用部门"
                  show-search
                  :filterTreeNode="filterTreeNode"
                  allow-clear
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :treeData="userDepartmentList"
                  :replaceFields="{
                    title: 'url',
                    key: 'id',
                    value: 'id'
                  }"
                  @change="changeUseDept"
                ></a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="使用人员" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-decorator="['principalId',{validateTrigger: ['change'],rules: [{ required: false, message: '请输入使用人员!' }]}]"
                  :allowClear="true"
                  placeholder="请选择使用人员"
                  @change="changeUseDeptPersonnel"
                  :style="{ width: showPrincipalName ? '30%' : '100%' }">
                  <a-select-option value="null">
                    其他
                  </a-select-option>
                  <a-select-option v-for="(item, index) in userOfServiceList" :key="index" :value="item.id">
                    {{ item.lastname }}
                  </a-select-option>
                </a-select>
                <a-input
                  v-if="showPrincipalName"
                  placeholder=""
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['principalName',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入!' }]}]"
                  style="width: calc(70% - 10px); margin-left: 10px"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="设备编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入设备编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['equipmentNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入设备编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="内部编码" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入内部编码"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['interiorCode',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入内部编码!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="归口部门负责人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-decorator="['relevantdeptUserId',{validateTrigger: ['change'],rules: [{ required: false, message: '请输入归口部门负责人!' }]}]"
                  :allowClear="true"
                  placeholder="请选择设备状态"
                  @change="changeCentralizeDeptPersonnel">
                  <a-select-option v-for="(item, index) in centralizedDepartmentCenter" :key="index" :value="item.id">
                    {{ item.lastname }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="otherParameters">
          <div class="titleDiv">
            <div class="title">来源信息</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="制造商" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入制造商"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['manufacturer',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入制造商!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="供应商" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入供应商"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['supplier',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入供应商!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="购置价值(万元)" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入购置价值"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['kansw',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入购置价值!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="税率" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入税率"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['taxRate',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入税率!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="购置净值" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入购置净值"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['qmzj',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入购置净值!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="采购订单编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入采购订单编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['purchaseOrder',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入采购订单编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="合同号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入合同号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['contractNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入合同号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="验收人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入验收人"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['accepterName',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入验收人!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="入库单号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入入库单号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['warehouseNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入入库单号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="WBS编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入WBS编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['wbsNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入WBS编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="项目编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入项目编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['projectNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入项目编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="采购人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入采购人"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['buyer',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入采购人!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="采购申请人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入采购申请人"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['purchaseRequestUser',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入采购申请人!' }]}]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="otherParameters">
          <div class="titleDiv">
            <div class="title">其他信息</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="图号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入图号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['figureNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入图号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="SAP设备分类" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" @change="changeSapType" v-decorator="['sapType',{validateTrigger: ['change'],rules: [{ required: false, message: '请选择SAP设备分类!' }]}]" :allowClear="true" placeholder="请选择SAP设备分类">
                  <a-select-option v-for="(item, index) in SAPEquipmentClassifyList" :key="index" :value="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="SAP设备编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入SAP设备编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['sapNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入SAP设备编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="备注" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-textarea
                  placeholder="请输入备注"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['remark',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入备注!' }]}]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="otherParameters">
          <div class="titleDiv">
            <div class="title">专项信息</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="重要分类" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-decorator="['importanceType',{validateTrigger: ['change'],rules: [{ required: false, message: '请选择重要分类!' }]}]" :allowClear="true" placeholder="请选择重要分类">
                  <a-select-option v-for="(item, index) in importantClassificationList" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="是否核心设备" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-decorator="['ifkernel',{validateTrigger: ['change'],rules: [{ required: false, message: '请选择是否核心设备!' }]}]" :allowClear="true" placeholder="请选择是否核心设备">
                  <a-select-option v-for="(item, index) in yesOrNoList" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="专项类型" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" @change="changeSpecialType" v-decorator="['specialType',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择专项类型!' }]}]" :allowClear="true" placeholder="请选择专项类型">
                  <a-select-option v-for="(item, index) in specialClassificationList" :key="index" :value="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="是否环保设备" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-decorator="['ifenvionmental',{validateTrigger: ['change'],rules: [{ required: false, message: '请选择是否环保设备!' }]}]" :allowClear="true" placeholder="请选择是否环保设备">
                  <a-select-option v-for="(item, index) in yesOrNoList" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="是否保密设备" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-decorator="['ifsecurity',{validateTrigger: ['change'],rules: [{ required: false, message: '请选择是否保密设备!' }]}]" :allowClear="true" placeholder="请选择是否保密设备">
                  <a-select-option v-for="(item, index) in yesOrNoList" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="otherParameters">
          <div class="titleDiv">
            <div class="title">出厂信息</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="生产厂家" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入生产厂家"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['manufactureFactory',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入生产厂家!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="出厂日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择出厂日期"
                  v-decorator="['dateInProduced']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="出厂编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入出厂编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['factoryNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入出厂编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="供应技术资料说明" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入供应技术资料说明"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['instructionBook',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入供应技术资料说明!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="投用日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择投用日期"
                  v-decorator="['entryDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="维保合同到期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择维保合同到期"
                  v-decorator="['maintenanceDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="注册代码" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入注册代码"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['registerCode',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入注册代码!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="使用登记证号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入使用登记证号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['certificateNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入使用登记证号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="全国检验报告编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入全国检验报告编号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['inspectionReportNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入全国检验报告编号!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="外观质量" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入外观质量"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['quality',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入外观质量!' }]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="是否校准/定检" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-decorator="['ifverify',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择是否校验/定检!' }]}]" :allowClear="true" placeholder="请选择是否校验/定检">
                  <a-select-option v-for="(item, index) in yesOrNoList" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="入库日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择入库日期"
                  v-decorator="['arrivalDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="购置日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择购置日期"
                  v-decorator="['purchaseDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="到货日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择到货日期"
                  v-decorator="['deloveryDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="生产日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择生产日期"
                  v-decorator="['producedDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="出库日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择发放日期"
                  v-decorator="['outboundDeliveryDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="拨交日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择拨交日期"
                  v-decorator="['dateOfDelivery']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="报废日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择报废日期"
                  v-decorator="['retirementDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="资本化日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                  :showToday="false"
                  format="YYYY-MM-DD"
                  placeholder="请选择资本化日期"
                  v-decorator="['capitalizationDate']"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="otherParameters">
          <div class="titleDiv">
            <div class="title">资产信息</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="资产卡片号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input
                  placeholder="请输入资产卡片号"
                  autocomplete="off"
                  :disabled="false"
                  v-decorator="['assetNumber',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入资产卡片号!' }]}]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="otherParameters">
          <div class="titleDiv">
            <div class="title">设备类别</div>
          </div>
          <a-row :gutter="10">
            <a-col :span="8">
              <a-form-item label="设备类别" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-tree-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @change="changeEquipmentType"
                  v-decorator="['equipmentType',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择设备类别!' }]}]"
                  style="width: 100%"
                  placeholder="请选择设备类别"
                  allow-clear
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :treeData="equipmentClassList"
                  :replaceFields="{
                    title: 'name',
                    key: 'code',
                    value: 'code'
                  }"
                ></a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <a-row>
          <a-col class="ant-col" :span="24">
            <a-form-item :wrapper-col="{ span: 5, offset: 19 }">
              <div class="btn">
                <a-button type="primary" html-type="submit" class="submit" :loading="btnLoading">
                  保存
                </a-button>
                <a-button @click="cancel" class="cancel">
                  取消
                </a-button>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import {
  addOrEditEquipment, editEquipment,
  getDeptTreeList,
  getDictList,
  getfocalDepartmentsList,
  getUserDepartmentList
} from '@/api/equipmentLedger'
import { } from '@/api/assetLedger'
import { getDeviceTypeTree } from '@/api/deviceType'
import moment from 'moment'
import { getUserList } from '@/api/organizationalStructure'

export default {
  name: 'DrawerDetail',
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '',
      footer: false,
      placement: 'right',
      btnLoading: false,
      form: this.$form.createForm(this, { name: 'cancelApplication' }),
      labelCol: { style: 'width: 110px' },
      wrapperCol: { style: 'width: calc(100% - 120px)' },
      showPrincipalName: false,
      // 公司名称列表
      companyNameList: [],
      // 设备状态列表
      equipmentStatusList: [],
      // 使用人员/归口部门负责人
      userOfServiceList: [],
      // 归口部门负责人
      centralizedDepartmentCenter: [],
      // 归口部门列表
      relevantDepartmentList: [],
      // 使用部门列表
      userDepartmentList: [],
      // 专项类型列表
      specialClassificationList: [],
      // 设备类别列表
      equipmentClassList: [],
      // SAP设备分类列表
      SAPEquipmentClassifyList: [],
      // 重要分类列表
      importantClassificationList: [
        {
          id: 'A',
          name: 'A'
        },
        {
          id: 'B',
          name: 'B'
        },
        {
          id: 'C',
          name: 'C'
        },
        {
          id: 'D',
          name: 'D'
        }
      ],
      // 是否列表
      yesOrNoList: [
        {
          id: '是',
          name: '是'
        },
        {
          id: '否',
          name: '否'
        }
      ],
      // 是否列表
      yesOrNoSignList: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ],
      selectList: [],
      model: {},
      type: '',
      // 公司名称code
      subcompanycode: '',
      subcompanyname: '',
      // 使用部门code
      usedeptcode: '',
      // 使用部门name
      usedeptname: '',
      // 归口部门code
      relevantdeptcode: '',
      // 归口部门name
      relevantdeptname: '',
      // 使用人员code
      principalName: '',
      // 归口部门负责人code
      relevantdeptUserName: '',
      // 专项类型名称
      specialTypeName: '',
      // 设备状态名称
      equipmentStatusName: '',
      // SAP设备分类名称
      sapTypeName: '',
      // 设备类别名称
      equipmentTypeName: '',
      // 添加子设备时传的id
      pid: '',
      // 添加父设备时传的id
      sonId: ''
    }
  },
  created () {
    // 获取公司名称列表
    this.getCompanyNameList()
    // 获取设备状态列表
    this.getEquipmentStatusList()
    // 获取归口部门列表
    this.getRelevantDepartmentList()
    // 获取专项分类
    this.getSpecialClassificationList()
    // 获取设备类别
    this.getEquipmentClassList()
    // 获取SAP设备分类列表
    this.getSAPEquipmentClassifyList()
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    setPid (pid) {
      this.pid = pid
    },
    setSonId (sonId) {
      this.sonId = sonId
    },
    // 设置model 参数 修改时传入
    setModel (model, type = 'edit') {
      this.subcompanycode = model.subcompanycode
      this.subcompanyname = model.subcompanyname
      this.usedeptcode = model.usedeptcode
      this.usedeptname = model.usedeptname
      this.relevantdeptcode = model.relevantdeptcode
      this.relevantdeptname = model.relevantdeptname
      this.specialTypeName = model.specialTypeName
      this.equipmentTypeName = model.equipmentTypeName
      this.equipmentStatusName = model.equipmentStatusName
      this.sapTypeName = model.sapTypeName
      this.principalName = model.principalName
      this.relevantdeptUserName = model.relevantdeptUserName
      this.getUserDepartmentList(model.subcompanyid, model.subcompanyname)
      this.getUserOfServiceAndCentralizedList(model.depid)
      this.getCentralizedDepartmentCenterList(model.relevantdeptid)
      if (model.principalId) {
        this.showPrincipalName = false
      } else {
        this.showPrincipalName = true
      }
      this.$nextTick(() => {
        this.model = Object.assign({}, model)
        const obj = {
          'name': model.name,
          'specification': model.specification,
          'sign': model.sign,
          'subcompanyid': model.subcompanyid,
          'principalId': model.principalId ? model.principalId : 'null',
          'principalName': model.principalName,
          'equipmentNumber': model.equipmentNumber,
          'interiorCode': model.interiorCode,
          'manufacturer': model.manufacturer,
          'supplier': model.supplier,
          'kansw': model.kansw,
          'taxRate': model.taxRate,
          'qmzj': model.qmzj,
          'purchaseOrder': model.purchaseOrder,
          'contractNumber': model.contractNumber,
          'accepterName': model.accepterName,
          'warehouseNumber': model.warehouseNumber,
          'wbsNumber': model.wbsNumber,
          'projectNumber': model.projectNumber,
          'figureNumber': model.figureNumber,
          'sapNumber': model.sapNumber,
          'sapType': model.sapType,
          'importanceType': model.importanceType,
          'ifkernel': model.ifkernel,
          'specialType': model.specialType,
          'ifenvionmental': model.ifenvionmental,
          'manufactureFactory': model.manufactureFactory,
          'dateInProduced': model.dateInProduced ? moment(model.dateInProduced, 'YYYY-MM-DD HH:ss:dd') : '',
          'factoryNumber': model.factoryNumber,
          'instructionBook': model.instructionBook,
          'entryDate': model.entryDate ? moment(model.entryDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'maintenanceDate': model.maintenanceDate ? moment(model.maintenanceDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'purchaseDate': model.purchaseDate ? moment(model.purchaseDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'deloveryDate': model.deloveryDate ? moment(model.deloveryDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'producedDate': model.producedDate ? moment(model.producedDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'dateOfDelivery': model.dateOfDelivery ? moment(model.dateOfDelivery, 'YYYY-MM-DD HH:ss:dd') : '',
          'outboundDeliveryDate': model.outboundDeliveryDate ? moment(model.outboundDeliveryDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'retirementDate': model.retirementDate ? moment(model.retirementDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'capitalizationDate': model.capitalizationDate ? moment(model.capitalizationDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'arrivalDate': model.arrivalDate ? moment(model.arrivalDate, 'YYYY-MM-DD HH:ss:dd') : '',
          'registerCode': model.registerCode,
          'certificateNumber': model.certificateNumber,
          'inspectionReportNumber': model.inspectionReportNumber,
          'quality': model.quality,
          'ifverify': model.ifverify,
          'equipmentType': model.equipmentType,
          'assetNumber': model.assetNumber,
          'usedeptid': model.usedeptid,
          'relevantdeptid': model.relevantdeptid,
          'equipmentStatus': model.equipmentStatus,
          'relevantdeptUserId': model.relevantdeptUserId,
          'buyer': model.buyer,
          'purchaseRequestUser': model.purchaseRequestUser,
          'remark': model.remark,
          'ifsecurity': model.ifsecurity
        }
        if (type === 'copy') {
          delete obj.equipmentNumber
          delete obj.interiorCode
        }
        this.form.setFieldsValue(obj)
      })
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      if (flag) {
        if (this.type === 'add') {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              'subcompanyid': this.companyNameList[0].id,
              'relevantdeptid': this.relevantDepartmentList[0].deptId,
              'sign': 0
            })
            this.subcompanycode = this.companyNameList[0].subcompanycode
            this.subcompanyname = this.companyNameList[0].subcompanyname
            this.relevantdeptcode = this.relevantDepartmentList[0].departmentcode
            this.relevantdeptname = this.relevantDepartmentList[0].departmentname
            this.getUserDepartmentList(this.companyNameList[0].id)
            this.getCentralizedDepartmentCenterList(this.relevantDepartmentList[0].deptId)
          })
        } else {
        }
      }
      this.visible = flag
    },
    // 重置children数组
    resetTheChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            item.disabled = true
            item.children = self.resetTheChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取公司名称列表
    getCompanyNameList () {
      const data = {
        paging: false
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.children.length > 0) {
              item.disabled = true
            }
            item.children = this.resetTheChildrenArray(item.children)
          })
          this.companyNameList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取设备状态列表
    getEquipmentStatusList () {
      const data = {
        pCode: 'sb_sbzt'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.equipmentStatusList = res.data
        }
      })
    },
    // 获取归口部门列表
    getRelevantDepartmentList () {
      getfocalDepartmentsList().then(res => {
        if (res.status === 0) {
          this.relevantDepartmentList = res.data
        }
      })
    },
    // 获取使用部门列表
    getUserDepartmentList (comid) {
      const data = {
        paging: false,
        comid: comid
      }
      getUserDepartmentList(data).then(res => {
        if (res.status === 0) {
          this.userDepartmentList = res.data
        }
      })
    },
    // 获取使用人员
    getUserOfServiceAndCentralizedList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.userOfServiceList = res.data
        }
      })
    },
    // 获取归口部门负责人
    getCentralizedDepartmentCenterList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.centralizedDepartmentCenter = res.data
        }
      })
    },
    // 获取专项类型
    getSpecialClassificationList () {
      const data = {
        pCode: 'sb_zxlx'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.specialClassificationList = res.data
        }
      })
    },
    // 获取设备类别
    getEquipmentClassList () {
      getDeviceTypeTree().then(res => {
        if (res.status === 0) {
          this.equipmentClassList = res.data
        }
      })
    },
    // 获取SAP设备分类
    getSAPEquipmentClassifyList () {
      const data = {
        pCode: 'zcfl'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.SAPEquipmentClassifyList = res.data
        }
      })
    },
    // 改变公司选择
    changeCompany (value, label, extra) {
      if (extra.triggerNode) {
        this.subcompanycode = extra.triggerNode.$vnode.data.props.dataRef.subcompanycode
        this.subcompanyname = extra.triggerNode.$vnode.data.props.dataRef.subcompanyname
      } else {
        this.subcompanycode = ''
        this.subcompanyname = ''
      }
      this.form.setFieldsValue(
        {
          usedeptid: undefined,
          principalId: undefined,
          principalName: undefined,
          relevantdeptUserId: undefined,
          relevantdeptid: undefined
        }
      )
      // 重置使用部门下拉列表
      this.userDepartmentList = []
      // 重置使用部门
      this.usedeptcode = ''
      this.usedeptname = ''
      // 重置使用人员/归口部门负责人下拉列表
      this.userOfServiceList = []
      this.centralizedDepartmentCenter = []
      // 重置使用人员
      this.principalName = ''
      // 重置归口部门负责人
      this.relevantdeptcode = ''
      this.relevantdeptname = ''
      this.relevantdeptUserName = ''
      // 获取使用部门
      this.getUserDepartmentList(value)
    },
    // 改变设备类别
    changeEquipmentType (value, label, extra) {
      if (extra.triggerNode) {
        this.equipmentTypeName = extra.triggerNode.$vnode.data.props.dataRef.name
      } else {
        this.equipmentTypeName = ''
      }
    },
    // 改变专项类型
    changeSpecialType(value) {
      if (value) {
        const index = this.specialClassificationList.findIndex(item => item.code === value)
        this.specialTypeName = this.specialClassificationList[index].name
      } else {
        this.specialTypeName = ''
      }
    },
    // 改变设备状态
    changeEquipmentStatus(value) {
      if (value) {
        const index = this.equipmentStatusList.findIndex(item => item.code === value)
        this.equipmentStatusName = this.equipmentStatusList[index].name
      } else {
        this.equipmentStatusName = ''
      }
    },
    // 改变SAP设备分类
    changeSapType(value) {
      if (value) {
        const index = this.SAPEquipmentClassifyList.findIndex(item => item.code === value)
        this.sapTypeName = this.SAPEquipmentClassifyList[index].name
      } else {
        this.sapTypeName = ''
      }
    },
    // 改变归口部门
    changeRelevantDept (value) {
      if (value) {
        const index = this.relevantDepartmentList.findIndex(item => item.deptId === value)
        this.relevantdeptcode = this.relevantDepartmentList[index].departmentcode
        this.relevantdeptname = this.relevantDepartmentList[index].departmentname
        this.getCentralizedDepartmentCenterList(value)
      } else {
        this.relevantdeptcode = ''
        this.relevantdeptname = ''
      }
      //  重置归口部门负责人
      this.$nextTick(() => {
        this.form.setFieldsValue({
          relevantdeptUserId: undefined
        })
      })
      this.relevantdeptUserName = ''
    },
    // 改变使用部门选择
    changeUseDept (value, label, extra) {
      if (extra.triggerNode) {
        this.usedeptcode = extra.triggerNode.$vnode.data.props.dataRef.departmentcode
        this.usedeptname = extra.triggerNode.$vnode.data.props.dataRef.departmentname
        this.getUserOfServiceAndCentralizedList(extra.triggerNode.$vnode.data.props.dataRef.depid)
      } else {
        this.usedeptcode = ''
        this.usedeptname = ''
      }
      //  重置使用人员
      this.$nextTick(() => {
        this.form.setFieldsValue({
          principalId: undefined,
          principalName: undefined
        })
      })
      this.userOfServiceList = []
      this.principalName = ''
    },
    // 改变使用人员
    changeUseDeptPersonnel (value) {
      this.form.setFieldsValue({
        principalName: undefined
      })
      if (value) {
        if (value === 'null') {
          this.showPrincipalName = true
        } else {
          this.showPrincipalName = false
          const index = this.userOfServiceList.findIndex(item => item.id === value)
          this.principalName = this.userOfServiceList[index].lastname
        }
      } else {
        this.principalName = ''
        this.showPrincipalName = false
      }
    },
    // 改变归口部门负责人
    changeCentralizeDeptPersonnel (value) {
      if (value) {
        const index = this.centralizedDepartmentCenter.findIndex(item => item.id === value)
        this.relevantdeptUserName = this.centralizedDepartmentCenter[index].lastname
      } else {
        this.relevantdeptUserName = ''
      }
    },
    // 搜索使用部门
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 提交
    handleSubmit (e) {
      e.preventDefault()
      this.btnLoading = true
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          params.subcompanycode = this.subcompanycode
          params.subcompanyname = this.subcompanyname
          params.usedeptcode = this.usedeptcode
          params.usedeptname = this.usedeptname
          params.relevantdeptcode = this.relevantdeptcode
          params.relevantdeptname = this.relevantdeptname
          params.specialTypeName = this.specialTypeName
          params.equipmentTypeName = this.equipmentTypeName
          params.equipmentStatusName = this.equipmentStatusName
          params.sapTypeName = this.sapTypeName ? this.sapTypeName : null
          params.principalName = params.principalId === 'null' ? params.principalName : this.principalName
          params.relevantdeptUserName = this.relevantdeptUserName
          params.dateInProduced = params.dateInProduced ? params.dateInProduced.format('YYYY-MM-DD 00:00:00') : ''
          params.entryDate = params.entryDate ? params.entryDate.format('YYYY-MM-DD 00:00:00') : ''
          params.maintenanceDate = params.maintenanceDate ? params.maintenanceDate.format('YYYY-MM-DD 00:00:00') : ''
          params.purchaseDate = params.purchaseDate ? params.purchaseDate.format('YYYY-MM-DD 00:00:00') : ''
          params.deloveryDate = params.deloveryDate ? params.deloveryDate.format('YYYY-MM-DD 00:00:00') : ''
          params.producedDate = params.producedDate ? params.producedDate.format('YYYY-MM-DD 00:00:00') : ''
          params.dateOfDelivery = params.dateOfDelivery ? params.dateOfDelivery.format('YYYY-MM-DD 00:00:00') : ''
          params.outboundDeliveryDate = params.outboundDeliveryDate ? params.outboundDeliveryDate.format('YYYY-MM-DD 00:00:00') : ''
          params.retirementDate = params.retirementDate ? params.retirementDate.format('YYYY-MM-DD 00:00:00') : ''
          params.capitalizationDate = params.capitalizationDate ? params.capitalizationDate.format('YYYY-MM-DD 00:00:00') : ''
          params.arrivalDate = params.arrivalDate ? params.arrivalDate.format('YYYY-MM-DD 00:00:00') : ''
          if (params.principalId === 'null') {
            params.principalId = null
          }
          if (this.type === 'edit') {
            params.id = this.model.id
          }
          if (this.pid || this.model.pid) {
            params.pid = this.pid ? this.pid : this.model.pid
          }
          if (this.sonId || this.model.sonId) {
            params.sonId = this.sonId ?  this.sonId : this.model.sonId
          }
          addOrEditEquipment(params).then(res => {
            if (res.status === 0) {
              this.$message.success('保存成功')
              this.$emit('getTableData', false)
              this.$emit('getDataTabs', params.id)
              this.btnLoading = false
              this.cancel()
            } else {
              this.$message.error(res.info.message)
              this.btnLoading = false
            }
          })
        } else {
          this.btnLoading = false
        }
      })
    },
    // 关闭抽屉
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 重置
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.userDepartmentList = []
        this.userOfServiceList = []
        // 重置使用人员
        this.principalName = ''
        this.showPrincipalName = false
        // 重置归口部门负责人
        this.relevantdeptUserName = ''
        this.subcompanycode = ''
        this.subcompanyname = ''
        this.usedeptcode = ''
        this.usedeptname = ''
        this.relevantdeptcode = ''
        this.relevantdeptname = ''
        this.specialTypeName = ''
        this.equipmentTypeName = ''
        this.equipmentStatusName = ''
        this.sapTypeName = ''
        this.pid = ''
        this.sonId = ''
      })
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
  overflow: hidden;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title{
    color: #08409F;
    padding-left: 8px;
    font-weight: bold;
  }
}
.inputDiv {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.btn {
   display: flex;
   flex-direction: row;
   justify-content: flex-end;
  .cancel {
    margin-left: 20px;
  }
 }
/deep/.ant-form-item {
  display: flex;
  margin-bottom: 12px;
}
/deep/.ant-col-md-5 {
  width: 20% !important;
  margin-bottom: 12px;
}
/deep/.ant-col-md-9 {
  width: 40% !important;
  margin-bottom: 12px;
}
/deep/.ant-form-explain {
  position: absolute;
}
</style>
